<template>
  <v-btn
    class="elevation-0 mx-2"
    color="#009900"
    @click="search"
    :loading="loading"
    depressed
    :disabled="disable"
    style="color: white"
  >
    <v-icon class="mr-2" style="color: white">
      article
    </v-icon>
    Gerar Excel
  </v-btn>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as XLSX from "xlsx";
import dayjs from 'dayjs';

export default {
  name:"GenerateExcel",
  props:{
    head:{type:Array,
      default:  function () {
      return [];
    }},
    itens: {type:Array,
      default:  function () {
      return [];
    }},
    title: {type: String, default: ""},
    reportData: {
      type: Function,
      required: false,
    },
    disable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({ loading: false }),
  computed: {
    ...mapState({
      user: (state) => state.global.user,
    }),
  },
  methods:{
    gerarExcel(json) {
      //TODO: apos adaptar as demais telas remover
      const data = json || this.itens
      const remameKeys = data.map((item) => {
        const novoItem = {}
        Object.keys(item).forEach((chave, index) => {
          this.head.map((head) => {
            if (head.value == chave) return (novoItem[head.text] = item[chave])
          })
        })
        return novoItem
      })

      const generalDate = dayjs().format('DD/MM/YYYY - HH:mm:ss')
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.json_to_sheet(remameKeys)

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')

      XLSX.writeFile(workbook, `${this.title} ${generalDate} .xlsx`)
    },
      removeActions(headers){
      var index = headers.indexOf("Ações");
      if(index == -1) return ;
      return headers.splice(index, 1)
    },
    async search() {
      this.loading = true
      try {
        const json = await this.reportData()
        this.loading = false
        this.gerarExcel(json)
      } catch (error) {
        this.loading = false
      }
    }

  }
}

</script>
